module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/修饰文字.17cfb88a.png";